import { render } from "./AppHeader.vue?vue&type=template&id=68b53c48&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=68b53c48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b53c48"]])

export default __exports__